import DirectoryApiModel from '../../abstracts/DirectoryApiModel';

export default class ResetPasswordRequestModel extends DirectoryApiModel {
	static get path(): string {
		return '/reset_password_requests';
	}
}
